exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".style__priceFooter___1mTQr{background-color:#f1f1f1;position:fixed;bottom:0;right:0;left:0;padding:20px 15%;height:175px;z-index:3;overflow-y:scroll}.style__questionSidebar___1Tuwg{position:fixed;top:60px;bottom:175px;overflow-y:scroll}.style__questionSidebar___1Tuwg::-webkit-scrollbar{width:0;background:transparent}.style__filtersMain___1Lm9T{margin-bottom:175px}", ""]);

// exports
exports.locals = {
	"priceFooter": "style__priceFooter___1mTQr",
	"questionSidebar": "style__questionSidebar___1Tuwg",
	"filtersMain": "style__filtersMain___1Lm9T"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[name]__[local]___[hash:base64:5]!./src/containers/jewelry/style.css
// module id = 717
// module chunks = 0